import cloneDeep from 'lodash.clonedeep';
import { action, makeObservable, observable } from 'mobx';
import { FormEvent, MouseEvent } from 'react';
import { IMealGroupEditModal } from '../types/mealGroupEditModal';
import { LOCALES, defaulLangTextValidation, defaultTTranslate } from '~/constants/main';
import { modalStore } from '~/mobx/modalStore';
import { ILangTextValidation } from '~/types/main';
import { emptyNameValidation } from '~/utils/validation';

class MealGroupEditModalStore {
  constructor() {
    makeObservable(this);
  }

  private sizeId: IMealGroupEditModal['id'] = 0;
  private onSubmitHandler: IMealGroupEditModal['onSubmit'] = () => {
    return;
  };
  private onDeleteHandler: IMealGroupEditModal['onDelete'] = () => {
    return;
  };

  @observable public name: IMealGroupEditModal['name'] = defaultTTranslate;

  public initStore = (props: IMealGroupEditModal) => {
    this.sizeId = props.id;
    this.onSubmitHandler = props.onSubmit;
    this.onDeleteHandler = props.onDelete;

    this.name = props.name;

    this.validation = cloneDeep(defaulLangTextValidation);
  };

  @action public onChangeName = (text: string, locales: LOCALES) => {
    this.name = { ...this.name, [locales]: text };

    if (!this.isValid) this.setValidation();
  };

  @action public onSubmit = (event: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    this.setValidation();

    if (!this.isValid) return;

    this.onSubmitHandler(this.sizeId, this.name);
    this.onCloseModal();
  };

  @action public onDelete = () => {
    this.onDeleteHandler(this.sizeId);
  };

  private get isValid(): boolean {
    return this.validation.enValid && this.validation.arValid;
  }

  @observable public validation: ILangTextValidation = cloneDeep(defaulLangTextValidation);
  private setValidation = () => {
    this.validation = cloneDeep(defaulLangTextValidation);

    [this.validation] = emptyNameValidation(this.name, this.validation, true);
  };

  @action public onCloseModal = () => {
    modalStore.closeMealGroupEditModal();
  };
}

export const mealGroupEditModalStore = new MealGroupEditModalStore();
